export default __webpack_public_path__ + "static/media/judihollder.417cedc3.png";